import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SwPush} from '@angular/service-worker';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

export type PushState = 'unsupported' | 'blocked' | 'off' | 'on';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  public static api = environment.baseUrl + '/api/private/push';

  constructor(private http: HttpClient, private swPush: SwPush) {
  }

  // rxjs 6 has no firstValueFrom
  private static first<T>(source: Observable<T>): Promise<T> {
    return source.pipe(take(1)).toPromise() as Promise<T>;
  }

  async getState(): Promise<PushState> {
    if (!this.swPush.isEnabled || !('Notification' in window)) {
      return 'unsupported';
    }
    if (Notification.permission === 'denied') {
      return 'blocked';
    }
    const subscription = await PushNotificationService.first(this.swPush.subscription);
    return subscription ? 'on' : 'off';
  }

  // Must be called from a user gesture (click): iOS rejects permission prompts otherwise
  async enable(): Promise<void> {
    const {publicKey} = await PushNotificationService.first(
      this.http.get<{ publicKey: string }>(PushNotificationService.api + '/public-key'));
    const subscription = await this.swPush.requestSubscription({serverPublicKey: publicKey});
    await PushNotificationService.first(this.http.post(PushNotificationService.api + '/subscribe', subscription.toJSON()));
  }

  async disable(): Promise<void> {
    const subscription = await PushNotificationService.first(this.swPush.subscription);
    if (!subscription) {
      return;
    }
    await PushNotificationService.first(this.http.post(PushNotificationService.api + '/unsubscribe', {endpoint: subscription.endpoint}));
    await this.swPush.unsubscribe();
  }
}
